import React from 'react';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
const basicPlugin = Plugins.name('Basic');

const Subscript = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <sub {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </sub>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Subscript',
  icon: {type: 'Component', value: [basicPlugin, iconName('Subscript')]},
  showEmpty: false,
  render: Subscript,
  fields: {children: TListOfElement},
});

export default config;
